import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ColDef, ICellRendererParams, RowNode } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { IconName } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';

@Component({
    selector: 'clickable-renderer',
    template: `
        <p-icon-image
            *ngIf="iconImage && !hideText && value && !disableLink"
            class="icon-before"
            [name]="iconImage"
            size="sm"
            (click)="clickEvent(node)"
        ></p-icon-image>
        <a
            *ngIf="!hideText && value"
            class="p-paragraph-2"
            [ngClass]="{ 'grid-link p-tpgr-link': !disableLink, disabled: disabled }"
            [attr.automation-id]="automationId"
            (click)="clickEvent(node)"
            >{{ text }}
        </a>
        <p-icon *ngIf="icon && !hideIcon(node)" [disabled]="disabled" [name]="icon" [color]="iconColor" (click)="clickEvent(node)"></p-icon>
    `,
    styleUrls: ['./clickable-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClickableRendererComponent implements ICellRendererAngularComp {
    public value!: boolean;
    public text!: string;
    public automationId!: string;
    public node!: RowNode;
    public disableLink!: boolean;
    public icon?: string;
    public iconImage?: IconName;
    public disabled = false;
    protected itemId: number | null = null;
    protected field: string | undefined;
    protected params!: ICellRendererParams;
    protected iconColor!: ColorName;

    public clickEvent = (node?: RowNode): void => {};
    protected hideIcon = (node: RowNode): boolean => {
        return false;
    };
    public setParams = (params: ICellRendererParams): void => {};
    hideText!: boolean;

    constructor(private cd: ChangeDetectorRef) {}

    public agInit(params: ICellRendererParams): void {
        this.initialParams(params);
    }

    private initialParams(params: ICellRendererParams): void {
        const colDef = params.colDef as ColDef;
        const data = colDef.cellRendererParams;
        const { clickEvent, displayText, idProp, disableLink, icon, iconImage, hideText, hideIcon, iconColor } = data || {};
        this.value = params.getValue?.();
        this.text = !!displayText ? displayText(params.node.data) : params.getValue?.();
        this.field = colDef.field;
        this.node = params.node;
        this.hideText = hideText || false;
        this.itemId = !!idProp ? params.node.data?.[idProp] : null;
        this.automationId = 'dialog_renderer-app_' + this.itemId + '-field_' + this.field;
        this.disableLink = typeof disableLink === 'function' ? disableLink(params.node.data) : disableLink || false;
        this.clickEvent = clickEvent || this.clickEvent;
        this.icon = icon || undefined;
        this.iconImage = typeof iconImage === 'function' ? iconImage(params.node.data) : iconImage || undefined;
        this.hideIcon = hideIcon || this.hideIcon;
        this.disabled = data.disabled || false;
        this.iconColor = iconColor;
        this.params = params;
        this.setParams(params);
    }

    public refresh(_params: ICellRendererParams): boolean {
        this.initialParams(_params);
        this.cd.detectChanges();
        return true;
    }
}
